import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { AdministrativeUnit } from "../models/organizations/administrative-unit";
import {
  CreateUserRequest,
  UpdateUserRequest,
  User,
  UserManagementView,
  UserType,
} from "../models/user";

@Injectable({
  providedIn: "root",
})
export class UserService {
  baseUrl = "api/users/";

  data$: Observable<AdministrativeUnit[]>;
  administrativeUnits: AdministrativeUnit[];

  constructor(private http: HttpClient) { }

  searchUsers(userSearchParameters) {
    return this.http.get<User[]>(this.baseUrl, {
      params: userSearchParameters,
    });
  }

  saveUser(user: User): Observable<User> {
    return this.http.put<User>(this.baseUrl, user);
  }

  getUserAdministrativeUnits() {
    return this.http.get<AdministrativeUnit[]>(`${this.baseUrl}user-tenants`);
  }

  getAUs() {
    return this.http.get<AdministrativeUnit[]>(`${this.baseUrl}all-aus`);
  }

  getAllAdministrativeUnits() {
    if (!this.data$) {
      this.data$ = this.http
        .get<AdministrativeUnit[]>(`${this.baseUrl}all-tenants`)
        .pipe(shareReplay(1));
      this.data$.subscribe((data) => (this.administrativeUnits = data));
    }
    return this.data$;
  }

  sendTestEmail(user: User) {
    return this.http.post<any>(this.baseUrl + "send-test-notification", user);
  }

  getUsersOverview(): Observable<UserManagementView[]> {
    return this.http.get<UserManagementView[]>(`${this.baseUrl}overview`);
  }

  create(createUserRequest: CreateUserRequest) {
    return this.http.post<UserManagementView>(
      `${this.baseUrl}create`,
      createUserRequest
    );
  }

  update(data: UpdateUserRequest) {
    return this.http.post<UserManagementView>(`${this.baseUrl}update`, data);
  }

  getDetail(userId: string, administrativeUnitId: string) {
    return this.http.get<any>(
      `${this.baseUrl}detail/${userId}/${administrativeUnitId}`
    );
  }

  searchForUser(email: string, firstName: string, lastName: string) {
    return this.http.get<boolean>(`${this.baseUrl}exists`, {
      params: {
        email: email || "",
        firstName: firstName || "",
        lastName: lastName || "",
      },
    });
  }

  getRoles(userType: UserType, organizationId: string) {
    return this.http.get<{ id: string; name: string }[]>(
      `${this.baseUrl}roles`,
      {
        params: {
          userType: userType.toString(),
          organizationId: organizationId,
        },
      }
    );
  }

  getUsersByRoleNameAndAdministrativeUnit(roleName: string, administrativeUnitId: string) {
    return this.http.get<User[]>(
      `${this.baseUrl}users-by-role-and-au/${roleName}/${administrativeUnitId}`);
  }
}
